import {observer} from "mobx-react"
import React, {Component} from "react"
import PropTypes from "prop-types"
import {Table} from "semantic-ui-react"
import Price from "components/Price/Price"
import _ from "lodash"

@observer
export default class ProductTableReadOnly extends Component {
	static propTypes = {
		list    : PropTypes.object,
		cart    : PropTypes.object,
		onChange: PropTypes.func,
		products: PropTypes.array,
		minimal : PropTypes.bool
	}

	constructor() {
		super()
	}

	render() {
		console.log('read ONLY table:',this.props);
		let {list, cart, products, onChange, minimal, showTax} = this.props
		let positions = list || products
		if ( list ) positions = list.products
		let rows = _.map( positions, ( product, index ) => {
			return (
				<ProductRow showTax={showTax} minimal={minimal} key={index} index={index} onChange={onChange} list={list} cart={cart} product={product} />
			)
		} )
		return (
			<Table className={"ProductTableReadOnly"}>
				<colgroup>
					<col width="50" />
					<col width=""/>
					<col width="30%" />
					<col width="10%" />
					<col width="10%" />
					<col width="10%" />
				</colgroup>
				<thead>
				<tr>
					<th>{translate("Artikel")}</th>
					<th>&nbsp;</th>
					{!minimal && <th>{translate("Preis/Stück")}</th>}
					<th>{translate( "Preis/VE" )}</th>
					<th>{translate( "Menge" )}</th>
					{showTax && <th>{translate( "Steuer" )}</th>}
					<th className="tr">{translate( "Summe" )}</th>
				</tr>
				</thead>
				<tbody>
				{rows}
				</tbody>
			</Table>
		)
	}
}

const ProductRow = ( {product, minimal, showTax} ) => {
	return (
		<tr>
			<td>
				<img height="34"
					 src={product.img_src_small}
					 alt="" />
			</td>
			<td>
				<strong>{product.article_nr}</strong> <span className="product-title">{product.title}</span><br />
				{!minimal && <span className="amount black-50 ">{translate( "PU" )} {product.unit_multi} {translate( "piece" )}</span>}
			</td>
			{!minimal && <td><Price>{product.price}</Price></td>}
			<td><Price>{product.price * product.unit_multi}</Price></td>
			<td>
				<span className="unit_multi ">{product.count} {translate( "PU" )}</span> <br />
				{!minimal && <span className="amount black-50">{product.count * product.unit_multi}&nbsp;{translate( "piece" )}</span>}

			</td>
			{showTax && <td>
				<div><Price>{product.price * product.count * product.unit_multi * product.taxRate}</Price></div>
				<div className={"black-60"}>{product.taxRate * 100} %</div>
			</td>}
			<td className="tr"><Price>{product.price * product.count * product.unit_multi}</Price></td>
		</tr>
	)
}

ProductRow.propTypes = {
	index   : PropTypes.any,
	list    : PropTypes.object,
	cart    : PropTypes.object,
	onChange: PropTypes.func,
	product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/inware/components/Product/ProductTableReadOnly.js